import React from 'react';
import p from '../../static/meetainImage3.png';
import { Row, Col, Typography } from 'antd';
import Center from './Center';
import { StyleSheet, css } from 'aphrodite';
import bg from '../../static/bg-pattern.png';
import logo from '../../static/Games_Keys_logo-4.png';

let styles = StyleSheet.create({
	background: {
		background: `url(${bg}), linear-gradient(to left, #7b4397, #dc2430)`,
		padding: '15% 0 15% 0%',
	},
	VerticalCenter: {
		textAlign: 'center',
	},
	typed: {
		color: '#fff',
		// fontSize: 'min(36px,3vw);'
	},
	img: {
		// float: 'right',
		height: 'auto',
		width: 'min(450px,40vw)',
	},
	btn: {
		border: `1px solid`,
		padding: `15px 20px`,
		// fontSize: 'min(1vw,36px)',
		borderRadius: '300px',
		color: '#fff',
		// letterSpacing: '2px',
		backgroundColor: 'transparent',
	},
	maxheight: {
		maxheight: '5px !important',
	},
});
const Intro1 = () => {
	return (
		<Row justify="center" className={css(styles.background)}>
			<Col
				className={css(styles.VerticalCenter)}
				xs={{ span: 24 }}
				sm={{ span: 24 }}
				md={{ span: 24 }}
				lg={{ span: 12 }}
				xl={{ span: 12 }}
				xxl={{ span: 12 }}
			>
				<Center className={css(styles.typed)}>
					<Typography.Title level={1} className={css(styles.typed)}>
						Meetain is an online multiplayer <br /> card game available for IOS devices.
					</Typography.Title>
				</Center>
				<div style={{ margin: `5%` }}>
					<Center>
						<Typography.Title level={4}>
							<a className={css(styles.btn)} href="https://itunes.apple.com/kw/app/meetain/id1089582421?mt=8">
								START PLAYING FOR FREE!
							</a>
						</Typography.Title>
					</Center>
				</div>
			</Col>
			<Col
				className={css(styles.VerticalCenter)}
				xs={{ span: 24 }}
				sm={{ span: 24 }}
				md={{ span: 24 }}
				lg={{ span: 12 }}
				xl={{ span: 12 }}
				xxl={{ span: 12 }}
			>
				<Center>
					<img src={p} className={css(styles.img)} />
					{/* <img src={p} alt="" className={css(styles.img)} /> */}
					<br />
					<br />
					<div style={{ display: 'inline-block' }}>
						<Typography.Title className={css(styles.typed)} level={4}>
							"Addictive IOS Games To Kill Boredom" by
						</Typography.Title>

						<Row justify="center" align="middle">
							<Col span={12}>
								<Typography.Title>
									<a href="https://gameskeys.net/addictive-ios-games-to-kill-boredom/">
										<img src={logo} className={css(styles.btn, styles.maxheight)} />
									</a>
								</Typography.Title>
							</Col>
						</Row>
					</div>
				</Center>
			</Col>
		</Row>
	);
};

export default Intro1;
